(function () {
function $db57845a13a88892$var$render_world_frame(world, context, clear_color, entity_styles) {
    context.save();
    // Clear canvas.
    context.fillStyle = clear_color;
    context.fillRect(0, 0, context.canvas.width, context.canvas.height);
    // Flip vertical axis.
    context.translate(0, context.canvas.height);
    context.scale(1, -1);
    // Scale to world size.
    context.scale(context.canvas.width / world.options.size, context.canvas.height / world.options.size);
    // Draw entities.
    for(const entity_id in entity_styles){
        const { fill: fill } = entity_styles[entity_id];
        const entity = world.entity(parseInt(entity_id));
        context.beginPath();
        context.arc(entity.position.x, entity.position.y, entity.radius, 0, 2 * Math.PI);
        context.fillStyle = fill;
        context.fill();
    }
    context.restore();
}
function $db57845a13a88892$export$f4adcd6d36513d43(world, context, clear_color, entity_styles, frame_callback) {
    // Frame request loop.
    let frame_request = null;
    let last_frame_time = null;
    function on_animation_frame() {
        const now = performance.now();
        const real_dt = last_frame_time !== null ? (now - last_frame_time) / 1000 : 1 / 60;
        last_frame_time = now;
        world.step(real_dt);
        $db57845a13a88892$var$render_world_frame(world, context, clear_color, entity_styles);
        if (frame_callback) frame_callback();
        if (frame_request !== null) frame_request = requestAnimationFrame(on_animation_frame);
    }
    // Start animation.
    frame_request = requestAnimationFrame(on_animation_frame);
    return {
        pause () {
            if (frame_request !== null) {
                cancelAnimationFrame(frame_request);
                frame_request = null;
                last_frame_time = null;
            }
        },
        resume () {
            if (frame_request === null) {
                last_frame_time = performance.now();
                frame_request = requestAnimationFrame(on_animation_frame);
            }
        }
    };
}


class $9796a8d282a837f1$export$ac4bca90992eed1 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    clone() {
        return new $9796a8d282a837f1$export$ac4bca90992eed1(this.x, this.y);
    }
    assign(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    }
    normalize() {
        const factor = 1 / this.length();
        this.x *= factor;
        this.y *= factor;
        return this;
    }
    set_length(scalar) {
        const factor = scalar / this.length();
        this.x *= factor;
        this.y *= factor;
        return this;
    }
    add(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    }
    subtract(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    }
    scale(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    dot(other) {
        return this.x * other.x + this.y * other.y;
    }
    length_squared() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    distance_squared_to(other) {
        const dx = other.x - this.x;
        const dy = other.y - this.y;
        return dx * dx + dy * dy;
    }
}
function $9796a8d282a837f1$export$aa691064ea72083b(center_1, radius_1, center_2, radius_2) {
    return center_1.distance_squared_to(center_2) <= (radius_1 + radius_2) * (radius_1 + radius_2);
}



class $65cb2f496843b85e$export$63080c4de6cfc362 {
    constructor(top, left, width, height){
        this.top = top;
        this.left = left;
        this.width = width;
        this.height = height;
        this.bottom = this.top - this.height;
        this.right = this.left + this.width;
    }
    static from_center_and_radius(center_x, center_y, radius) {
        return new $65cb2f496843b85e$export$63080c4de6cfc362(center_y + radius, center_x - radius, radius, radius);
    }
    overlaps(other) {
        return other.left <= this.right && other.right >= this.left && other.bottom <= this.top && other.top >= this.bottom;
    }
}
class $65cb2f496843b85e$export$b82688eb02220411 {
    constructor(depth, bounds){
        this.depth = depth;
        this.bounds = bounds;
        this.node = {
            kind: "leaf",
            items: []
        };
        if (this.depth < 1) throw new Error("quadtree node cannot have depth < 1");
        else if (this.depth === 1) this.node = {
            kind: "leaf",
            items: []
        };
        else if (this.depth > 1) {
            const child_depth = depth - 1;
            const y = this.bounds.top;
            const x = this.bounds.left;
            const w2 = 0.5 * this.bounds.width;
            const h2 = 0.5 * this.bounds.height;
            this.node = {
                kind: "internal",
                sw: new $65cb2f496843b85e$export$b82688eb02220411(child_depth, new $65cb2f496843b85e$export$63080c4de6cfc362(y - h2, x, w2, h2)),
                se: new $65cb2f496843b85e$export$b82688eb02220411(child_depth, new $65cb2f496843b85e$export$63080c4de6cfc362(y - h2, x + w2, w2, h2)),
                nw: new $65cb2f496843b85e$export$b82688eb02220411(child_depth, new $65cb2f496843b85e$export$63080c4de6cfc362(y, x, w2, h2)),
                ne: new $65cb2f496843b85e$export$b82688eb02220411(child_depth, new $65cb2f496843b85e$export$63080c4de6cfc362(y, x + w2, w2, h2))
            };
        }
    }
    nr_items() {
        if (this.node.kind === "leaf") return this.node.items.length;
        else {
            let sum = 0;
            this.for_each_child((child)=>sum += child.nr_items());
            return sum;
        }
    }
    clear() {
        if (this.node.kind === "leaf") this.node.items.length = 0;
        else this.for_each_child((child)=>child.clear());
    }
    add(entity, target_bounds) {
        if (!target_bounds.overlaps(this.bounds)) return;
        else if (this.node.kind === "internal") this.for_each_child((child)=>{
            if (child.bounds.overlaps(target_bounds)) child.add(entity, target_bounds);
        });
        else if (!this.node.items.includes(entity)) this.node.items.push(entity);
    }
    remove(entity, target_bounds) {
        if (!target_bounds.overlaps(this.bounds)) return;
        else if (this.node.kind === "internal") this.for_each_child((child)=>{
            if (child.bounds.overlaps(target_bounds)) child.remove(entity, target_bounds);
        });
        else if (this.node.items.includes(entity)) {
            const index = this.node.items.indexOf(entity);
            this.node.items.splice(index, 1);
        }
    }
    for_each_child(callback) {
        if (this.node.kind === "leaf") return;
        callback(this.node.sw);
        callback(this.node.se);
        callback(this.node.nw);
        callback(this.node.ne);
    }
    for_each_leaf_with_at_least(threshold, callback) {
        if (this.nr_items() < threshold) return;
        else if (this.node.kind === "leaf") callback(this.node.items);
        else this.for_each_child((child)=>child.for_each_leaf_with_at_least(threshold, callback));
    }
}


class $c30043093d44fb83$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = options;
        this.quadtree = new (0, $65cb2f496843b85e$export$b82688eb02220411)(options.subdivisions, new (0, $65cb2f496843b85e$export$63080c4de6cfc362)(options.bounds_size, 0, options.bounds_size, options.bounds_size));
    }
    clear() {
        this.quadtree.clear();
    }
    add(entity) {
        this.quadtree.add(entity, (0, $65cb2f496843b85e$export$63080c4de6cfc362).from_center_and_radius(entity.position.x, entity.position.y, entity.radius));
    }
    remove(entity) {
        this.quadtree.remove(entity, (0, $65cb2f496843b85e$export$63080c4de6cfc362).from_center_and_radius(entity.position.x, entity.position.y, entity.radius));
    }
    moved(entity, old_position) {
        const old_bounds = (0, $65cb2f496843b85e$export$63080c4de6cfc362).from_center_and_radius(old_position.x, old_position.y, entity.radius);
        const new_bounds = (0, $65cb2f496843b85e$export$63080c4de6cfc362).from_center_and_radius(entity.position.x, entity.position.y, entity.radius);
        this.quadtree.remove(entity, old_bounds);
        this.quadtree.add(entity, new_bounds);
    }
    for_each_potential_collision_group(callback) {
        this.quadtree.for_each_leaf_with_at_least(2, (items)=>{
            callback(items);
        });
    }
}
// Finds roots of a quadratic.
function $c30043093d44fb83$var$quadratic_solution(a, b, c) {
    const b2_4ac = b * b - 4 * a * c;
    if (b2_4ac < 0) return {
        count: 0
    };
    else if (b2_4ac > 0) return {
        count: 2,
        x1: (-b + Math.sqrt(b2_4ac)) / (2 * a),
        x2: (-b - Math.sqrt(b2_4ac)) / (2 * a)
    };
    else return {
        count: 1,
        x1: -b / (2 * a)
    };
}
// Tests whether two discs with the specified velocities collide in the near future.
//
// c1, v1, r1:
//      The first disc's center, velocity, and radius.
// c2, v2, r2:
//      The second disc's center, velocity, and radius.
//
// Returns the time of collision or -1 if there is none.
function $c30043093d44fb83$var$collision_time(c1, v1, r1, c2, v2, r2) {
    // The squared distance between the two centers at time t is:
    //
    // (1)  D(t) = |(c1 + v1 * t) - (c2 + v2 * t)| ^ 2
    //
    // We are interested in finding whether D(t) <= (r1 + r2) ^ 2 on the interval [0, dt].
    // This is equivalent to solving the following equation:
    //
    // (2)   ((c1.x + v1.x * t) - (c2.x + v2.x * t)) ^ 2 +
    //       ((c1.y + v1.y * t) - (c2.y + v2.y * t)) ^ 2 -
    //       (r1 + r2) ^ 2 <= 0
    //
    // Rewrite:
    //
    //      (c1.x - c2.x + (v1.x - v2.x) * t) ^ 2 +
    //      (c1.y - c2.y + (v1.y - v2.y) * t) ^ 2 -
    //      (r1 + r2) ^ 2 <= 0
    //
    // Denote the components of c1 - c2 = [dc_x, dc_y], those of v1 - v2 [dv_x, dv_y], and call
    // r1 + r2 = R:
    //
    //      (dc_x + dv_x * t) ^ 2 +
    //      (dc_y + dv_y * t) ^ 2 -
    //      R ^ 2 <= 0
    //
    // Rewrite:
    //
    //      dc_x^2 + 2*dc_x*dv_x*t + (dv_x^2)*(t^2) +
    //      dc_y^2 + 2*dc_y*dv_y*t + (dv_y^2)*(t^2) -
    //      R ^ 2 <= 0
    //
    // Which can be expressed as:
    //
    //      a*(t^2) + b*t + c <= 0
    //
    // Where:
    //
    //      a = dv_x^2 + dv_y^2
    //      b = 2 * (dc_x*dv_x + dc_y*dv_y)
    //      c = dc_x^2 + dc_y^2 - R^2
    //
    // Solving this yields at most two solutions. All we have to do next is take the minimum
    // of the two that is also contained within the interval [0, dt].
    const dv_x = v1.x - v2.x;
    const dv_y = v1.y - v2.y;
    const dv_x2 = dv_x * dv_x;
    const dv_y2 = dv_y * dv_y;
    const dc_x = c1.x - c2.x;
    const dc_y = c1.y - c2.y;
    const dc_x2 = dc_x * dc_x;
    const dc_y2 = dc_y * dc_y;
    const solution = $c30043093d44fb83$var$quadratic_solution(dv_x2 + dv_y2, 2 * (dc_x * dv_x + dc_y * dv_y), dc_x2 + dc_y2 - (r1 + r2) * (r1 + r2));
    if (solution.count === 2) {
        const [t1, t2] = solution.x1 <= solution.x2 ? [
            solution.x1,
            solution.x2
        ] : [
            solution.x2,
            solution.x1
        ];
        if (t1 < 0 && t2 >= 0) return 0;
        return t1;
    } else if (solution.count === 1) return solution.x1;
    else return -1;
}
function $c30043093d44fb83$export$7f5d6ca1625060a8(entities, time_horizon) {
    let collisions = [];
    for(let j = 0; j < entities.length; ++j){
        const a = entities[j];
        for(let k = j + 1; k < entities.length; ++k){
            const b = entities[k];
            if (a.static && b.static) continue;
            const t = $c30043093d44fb83$var$collision_time(a.position, a.velocity, a.radius, b.position, b.velocity, b.radius);
            if (0 <= t && t <= time_horizon) collisions.push({
                entities: [
                    a,
                    b
                ],
                time: t
            });
        }
    }
    return collisions;
}
function $c30043093d44fb83$export$fd0a61d200b47931(entities) {
    const collisions = [];
    for(let j = 0; j < entities.length; ++j){
        const a = entities[j];
        for(let k = j + 1; k < entities.length; ++k){
            const b = entities[k];
            if (a.static && b.static) continue;
            if ((0, $9796a8d282a837f1$export$aa691064ea72083b)(a.position, a.radius, b.position, b.radius)) {
                collisions.push([
                    a,
                    b
                ]);
                break;
            }
        }
    }
    return collisions;
}
function $c30043093d44fb83$export$7b62f1d061fe35d9(a, b) {
    if (a.static && b.static) return;
    // Ensure static entity is always assigned to a:
    if (b.static) {
        const c = a;
        a = b;
        b = c;
    }
    const dx = a.position.clone().subtract(b.position).set_length(a.radius + b.radius);
    const du = a.velocity.clone().subtract(b.velocity);
    const coefficient_of_restitution = 0.5 * (a.elasticity + b.elasticity);
    const response = coefficient_of_restitution * 2 * du.dot(dx) / ((a.mass + b.mass) * dx.length_squared());
    if (!a.static) a.velocity.subtract(dx.clone().scale(response * b.mass));
    if (!b.static) b.velocity.subtract(dx.clone().scale(-response * a.mass));
}
function $c30043093d44fb83$export$9acaec0c61023416(a, b, distance) {
    if (a.static && b.static) return;
    const r = a.radius + b.radius + distance;
    const d2 = a.position.distance_squared_to(b.position);
    if (d2 >= r * r) return;
    const collision_axis = a.position.clone().subtract(b.position).normalize();
    const offset_magnitude = r - Math.sqrt(d2);
    if (a.static) b.position.add(collision_axis.scale(-offset_magnitude));
    else if (b.static) a.position.add(collision_axis.scale(offset_magnitude));
    else {
        a.position.add(collision_axis.clone().scale(0.5 * offset_magnitude));
        b.position.add(collision_axis.clone().scale(0.5 * -offset_magnitude));
    }
}


// Mass of static entities. Should be extremely large.
const $6436c79ae1195d8e$var$STATIC_ENTITY_MASS = Math.pow(10, 14);
// Minimum simulation time increment.
const $6436c79ae1195d8e$var$MIN_TIME_STEP_SIZE = 0.001;
// Minimum distance between entities after collision separation.
const $6436c79ae1195d8e$var$MIN_SEPARATION_DISTANCE = 0.001;
// Objects whose squared velocity is less than this are considered to be at rest.
const $6436c79ae1195d8e$var$REST_VELOCITY_THRESHOLD = 0.001;
function $6436c79ae1195d8e$var$step_entity(entity, dt) {
    const f = entity.applied_force;
    const m_inv = 1 / entity.mass;
    const p = entity.position;
    const v = entity.velocity;
    const a = 0.5 * dt * m_inv;
    p.x += dt * (v.x + a * f.x);
    p.y += dt * (v.y + a * f.y);
    const b = dt * m_inv;
    v.x += b * f.x;
    v.y += b * f.y;
}
class $6436c79ae1195d8e$export$812cd9544993280d {
    constructor(options){
        this.options = options;
        this.next_entity_id = 0;
        this.entities = new Map();
        this.collision_culler = new (0, $c30043093d44fb83$export$2e2bcd8739ae039)({
            subdivisions: options.collision_culling_subdivisions,
            bounds_size: options.size
        });
    }
    clear() {
        this.collision_culler.clear();
        this.entities.clear();
    }
    spawn(options) {
        const entity = {
            mass: options.static ? $6436c79ae1195d8e$var$STATIC_ENTITY_MASS : options.mass !== undefined ? options.mass : 1,
            radius: options.radius !== undefined ? options.radius : 1,
            elasticity: options.elasticity !== undefined ? options.elasticity : 0,
            static: options.static !== undefined ? options.static : false,
            position: options.position !== undefined ? new (0, $9796a8d282a837f1$export$ac4bca90992eed1)(options.position.x, options.position.y) : new (0, $9796a8d282a837f1$export$ac4bca90992eed1)(0, 0),
            velocity: options.velocity !== undefined ? new (0, $9796a8d282a837f1$export$ac4bca90992eed1)(options.velocity.x, options.velocity.y) : new (0, $9796a8d282a837f1$export$ac4bca90992eed1)(0, 0),
            applied_force: options.applied_force !== undefined ? new (0, $9796a8d282a837f1$export$ac4bca90992eed1)(options.applied_force.x, options.applied_force.y) : new (0, $9796a8d282a837f1$export$ac4bca90992eed1)(0, 0)
        };
        const id = this.next_entity_id;
        this.next_entity_id += 1;
        this.entities.set(id, entity);
        this.collision_culler.add(entity);
        return id;
    }
    remove(entity_id) {
        if (!this.entities.has(entity_id)) throw new Error("bad entity id");
        const entity = this.entities.get(entity_id);
        this.collision_culler.remove(entity);
        this.entities.delete(entity_id);
    }
    entity(entity_id) {
        if (!this.entities.has(entity_id)) throw new Error("bad entity id");
        const entity = this.entities.get(entity_id);
        return {
            ...entity,
            position: {
                x: entity.position.x,
                y: entity.position.y
            },
            velocity: {
                x: entity.velocity.x,
                y: entity.velocity.y
            },
            applied_force: {
                x: entity.applied_force.x,
                y: entity.applied_force.y
            }
        };
    }
    update(entity_id, options) {
        if (!this.entities.has(entity_id)) throw new Error("bad entity id");
        const entity = this.entities.get(entity_id);
        const old_position = entity.position.clone();
        if (options.mass !== undefined) entity.mass = options.mass;
        if (options.radius !== undefined) entity.radius = options.radius;
        if (options.elasticity !== undefined) entity.elasticity = options.elasticity;
        if (options.static !== undefined) {
            entity.static = options.static;
            if (entity.static) entity.mass = $6436c79ae1195d8e$var$STATIC_ENTITY_MASS;
        }
        if (options.position !== undefined) {
            entity.position.x = options.position.x;
            entity.position.y = options.position.y;
        }
        if (options.velocity !== undefined) {
            entity.velocity.x = options.velocity.x;
            entity.velocity.y = options.velocity.y;
        }
        if (options.applied_force !== undefined) {
            entity.applied_force.x = options.applied_force.x;
            entity.applied_force.y = options.applied_force.y;
        }
        if (options.position !== undefined || options.radius !== undefined) this.collision_culler.moved(entity, old_position);
    }
    for_each_entity(callback) {
        this.entities.forEach((_entity, entity_id)=>{
            callback(entity_id, this.entity(entity_id));
        });
    }
    step(dt) {
        if (dt <= 0) throw new Error("cannot step with dt <= 0");
        this.separate_colliding_entities();
        if (this.options.high_precision) this.step_with_high_precision(dt);
        else this.step_with_low_precision(dt);
        this.entities.forEach((entity)=>{
            if (entity.velocity.length_squared() < $6436c79ae1195d8e$var$REST_VELOCITY_THRESHOLD) {
                entity.velocity.x = 0;
                entity.velocity.y = 0;
            }
        });
    }
    separate_colliding_entities() {
        const old_entity_positions = new Map();
        this.collision_culler.for_each_potential_collision_group((group)=>{
            // Repeatedly find intersecting pairs, separate them, and check for new intersections.
            let intersecting_pairs = (0, $c30043093d44fb83$export$fd0a61d200b47931)(group);
            while(intersecting_pairs.length > 0){
                for (const [entity_1, entity_2] of intersecting_pairs){
                    if (!entity_1.static) old_entity_positions.set(entity_1, entity_1.position.clone());
                    if (!entity_2.static) old_entity_positions.set(entity_2, entity_2.position.clone());
                    (0, $c30043093d44fb83$export$9acaec0c61023416)(entity_1, entity_2, $6436c79ae1195d8e$var$MIN_SEPARATION_DISTANCE);
                    (0, $c30043093d44fb83$export$7b62f1d061fe35d9)(entity_1, entity_2);
                }
                intersecting_pairs = (0, $c30043093d44fb83$export$fd0a61d200b47931)(group);
            }
        });
        old_entity_positions.forEach((old_position, entity)=>{
            this.collision_culler.moved(entity, old_position);
        });
    }
    step_with_high_precision(dt) {
        const stepped_entities = new Set();
        const old_entity_positions = new Map();
        // Save entity starting positions.
        this.entities.forEach((entity)=>{
            old_entity_positions.set(entity, entity.position.clone());
        });
        // Handle groups of potentially colliding entities.
        this.collision_culler.for_each_potential_collision_group((group)=>{
            for(let i = 0; i < group.length; ++i)stepped_entities.add(group[i]);
            this.step_entity_group(group, dt);
        });
        // Some entities were already stepped forward in time during collision handling,
        // now we step the rest.
        this.entities.forEach((entity)=>{
            if (!stepped_entities.has(entity)) $6436c79ae1195d8e$var$step_entity(entity, dt);
        });
        old_entity_positions.forEach((previous_position, entity)=>{
            this.collision_culler.moved(entity, previous_position);
        });
    }
    step_entity_group(group, dt) {
        // Step forward in the time interval [now, now + dt] in small increments, ensuring that
        // collisions are resolved at their precise moment of occurrence.
        let t = dt;
        while(t > $6436c79ae1195d8e$var$MIN_TIME_STEP_SIZE){
            // Find the time of earliest collision.
            let earliest_collision = null;
            for (const collision of (0, $c30043093d44fb83$export$7f5d6ca1625060a8)(group, t))if (earliest_collision === null || collision.time < earliest_collision.time) earliest_collision = collision;
            const time_step = earliest_collision !== null ? earliest_collision.time : dt;
            // Step entire group up to the time of earliest collision.
            for (const entity of group)$6436c79ae1195d8e$var$step_entity(entity, time_step);
            // Handle the earliest collision.
            if (earliest_collision !== null) {
                (0, $c30043093d44fb83$export$7b62f1d061fe35d9)(earliest_collision.entities[0], earliest_collision.entities[1]);
                (0, $c30043093d44fb83$export$9acaec0c61023416)(earliest_collision.entities[0], earliest_collision.entities[1], $6436c79ae1195d8e$var$MIN_SEPARATION_DISTANCE);
            }
            // Update remaining time to move forward in time.
            t -= time_step;
        }
    }
    step_with_low_precision(dt) {
        this.entities.forEach((entity)=>{
            if (!entity.static) {
                const old_position = entity.position.clone();
                $6436c79ae1195d8e$var$step_entity(entity, dt);
                this.collision_culler.moved(entity, old_position);
            }
        });
    }
}



const $ee5fc0e5a1abec6c$var$WORLD_SIZE = 1;
const $ee5fc0e5a1abec6c$var$NR_PARTICLES = 50;
const $ee5fc0e5a1abec6c$var$PARTICLE_ENTITY_RADIUS_MIN = 0.02 * $ee5fc0e5a1abec6c$var$WORLD_SIZE * 30 / $ee5fc0e5a1abec6c$var$NR_PARTICLES;
const $ee5fc0e5a1abec6c$var$PARTICLE_ENTITY_RADIUS_MAX = 0.05 * $ee5fc0e5a1abec6c$var$WORLD_SIZE * 30 / $ee5fc0e5a1abec6c$var$NR_PARTICLES;
const $ee5fc0e5a1abec6c$var$PARTICLE_VELOCITY_MIN = 0.1 * $ee5fc0e5a1abec6c$var$WORLD_SIZE;
const $ee5fc0e5a1abec6c$var$PARTICLE_VELOCITY_MAX = 0.5 * $ee5fc0e5a1abec6c$var$WORLD_SIZE;
const $ee5fc0e5a1abec6c$var$PARTICLE_ELASTICITY = 0.95;
const $ee5fc0e5a1abec6c$var$PALETTE = [
    "red",
    "blue",
    "brown",
    "green",
    "orange",
    "magenta",
    "purple"
];
function $ee5fc0e5a1abec6c$var$random_in_range(lower, upper) {
    return lower + Math.random() * (upper - lower);
}
function $ee5fc0e5a1abec6c$var$setup() {
    const entity_styles = {};
    const world = new (0, $6436c79ae1195d8e$export$812cd9544993280d)({
        size: $ee5fc0e5a1abec6c$var$WORLD_SIZE,
        collision_culling_subdivisions: 3,
        high_precision: true
    });
    for(let i = 0; i < $ee5fc0e5a1abec6c$var$NR_PARTICLES; ++i){
        const radius = $ee5fc0e5a1abec6c$var$random_in_range($ee5fc0e5a1abec6c$var$PARTICLE_ENTITY_RADIUS_MIN, $ee5fc0e5a1abec6c$var$PARTICLE_ENTITY_RADIUS_MAX);
        const mass = Math.PI * radius * radius;
        const particle_id = world.spawn({
            mass: mass,
            radius: radius,
            elasticity: $ee5fc0e5a1abec6c$var$PARTICLE_ELASTICITY,
            position: {
                x: $ee5fc0e5a1abec6c$var$random_in_range(radius, world.options.size - radius),
                y: $ee5fc0e5a1abec6c$var$random_in_range(radius, world.options.size - radius)
            },
            velocity: new (0, $9796a8d282a837f1$export$ac4bca90992eed1)($ee5fc0e5a1abec6c$var$random_in_range(-1, 1), $ee5fc0e5a1abec6c$var$random_in_range(-1, 1)).set_length($ee5fc0e5a1abec6c$var$random_in_range($ee5fc0e5a1abec6c$var$PARTICLE_VELOCITY_MIN, $ee5fc0e5a1abec6c$var$PARTICLE_VELOCITY_MAX))
        });
        entity_styles[particle_id] = {
            fill: $ee5fc0e5a1abec6c$var$PALETTE[i % $ee5fc0e5a1abec6c$var$PALETTE.length]
        };
    }
    const canvas_elements = document.getElementsByClassName("demo-canvas");
    if (canvas_elements.length !== 1) throw new Error(`expected 1 demo canvas, found ${canvas_elements.length}`);
    const canvas = canvas_elements.item(0);
    if (!(canvas instanceof HTMLCanvasElement)) throw new Error(`expected canvas element, found ${typeof canvas}`);
    const context = canvas.getContext("2d", {
        alpha: false
    });
    if (context === null) throw new Error("cannot get rendering context");
    const controls = (0, $db57845a13a88892$export$f4adcd6d36513d43)(world, context, "white", entity_styles, ()=>{
        let total_velocity = 0;
        world.for_each_entity((entity_id, entity)=>{
            let update_required = false;
            if (entity.position.x < entity.radius) {
                entity.position.x = entity.radius;
                entity.velocity.x *= -1;
                update_required = true;
            }
            if (entity.position.x > world.options.size - entity.radius) {
                entity.position.x = world.options.size - entity.radius;
                entity.velocity.x *= -1;
                update_required = true;
            }
            if (entity.position.y < entity.radius) {
                entity.position.y = entity.radius;
                entity.velocity.y *= -1;
                update_required = true;
            }
            if (entity.position.y > world.options.size - entity.radius) {
                entity.position.y = world.options.size - entity.radius;
                entity.velocity.y *= -1;
                update_required = true;
            }
            if (update_required) world.update(entity_id, {
                position: entity.position,
                velocity: entity.velocity
            });
            total_velocity += entity.velocity.x + entity.velocity.y;
        });
        if (total_velocity === 0) controls.pause();
    });
}
window.addEventListener("DOMContentLoaded", $ee5fc0e5a1abec6c$var$setup);

})();
//# sourceMappingURL=index.cacfc28e.js.map
